module.exports = __webpack_public_path__ + "img/8_Load_Balancing_Algorithms_for_Modern_Systems.e9488940.jpeg";